<template>
    <el-form status-icon :model="motorForm" :rules="rulesMotor" ref="motorForm" @submit.native.prevent="enter"
             class="demo-ruleForm">
        <div>
            <el-row>
                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form-item label='Motor Adı'
                                  prop="motorAdi" class="margin-top-20">:
                        <el-input
                                v-model="motorForm.motorAdi"
                                placeholder='Motor Adı Giriniz'></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </div>
        <el-row class="col-p">
            <el-form-item>
                <el-button size="small" v-on:click="motorTanimla('motorForm')"
                           type="primary">
                    Tanımla
                </el-button>
            </el-form-item>
        </el-row>
    </el-form>

</template>

<script>
    import EventBus from '@/components/event-bus'

    import motorService from '../../../../WSProvider/OpsiyonService'
    import notification from '../../../../notification'
    export default {
        name: "MotorEkle",
        mounted() {
            this.getMotorListesi();
        },
        data() {
            return {
                motorListesi: [],
                motorForm: {
                    motorAdi: '',
                },
                rulesMotor: {
                    motorAdi: [{
                        required: true,
                        message: "Lütfen Kw Giriniz",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            getMotorListesi() {
                motorService.motorList(1, "", "").then((response) => {
                    if (response.status === 200) {
                        this.motorListesi = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            motorTanimla(formName) {
                var dizi = [];
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        motorService.motorTanimlama(this.motorForm.motorAdi).then((response) => {
                            if (response.status === 200) {
                                this.motorListesi.push(response.data);
                                this.motorListesi.forEach(function (value) {
                                    dizi.push({
                                        secenekAdi: value.motorAdi,
                                        secenekKodu: value.motorKodu,
                                    })
                                });
                                EventBus.$emit("opsiyonList", true)
                                // this.$store.commit('changeOpsiyonList', dizi);
                                notification.Status('success', this, 'Motor başarıyla eklendi.');
                                this.$refs[formName].resetFields();
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir motor zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>